import React from 'react';
import IconSvg, { IconSvgProps } from './IconSvg';

const ChevronRight = (props: IconSvgProps) => (
  <IconSvg {...props}>
    <path d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
  </IconSvg>
);

export default ChevronRight;
